import React from 'react';
import HeroSection from '../../components/common/HeroSection';

const PrivacyPolicy: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <HeroSection
        title="Privacy Policy"
        description="Your privacy is important to us. This policy explains how we collect, use, and protect your personal information."
      />
      <div className="container mx-auto px-4 py-8 md:py-12">
        <div className="prose prose-lg max-w-4xl mx-auto bg-white p-8 md:p-12 rounded-xl shadow-lg">
          {/*
            The `prose prose-lg` classes apply base styling.
            We'll add specific margin and leading utilities with `!` to override prose defaults where needed
            for enhanced spacing and readability.
            "Highlighting" indexed points (h2) is achieved through clear separation and existing prose font styling.
          */}

          <h2 className="!mt-0 !mb-4">1. Information We Collect</h2> {/* First heading, no top margin, standard bottom margin */}
          <p className="!mb-6 !leading-relaxed"> {/* Standard paragraph bottom margin and line height */}
            We may collect personal identification information from Users in a variety of ways, including, but not limited to,
            when Users visit our site, register on the site, place an order, subscribe to the newsletter, respond to a survey,
            fill out a form, and in connection with other activities, services, features or resources we make available on our Site.
            Users may be asked for, as appropriate, name, email address, mailing address, phone number.
          </p>

          <h2 className="!mt-10 !mb-4">2. How We Use Collected Information</h2> {/* Increased top margin for section separation */}
          <p className="!mb-3 !leading-relaxed"> {/* Tighter bottom margin before a list */}
            ASCIIBytes may collect and use Users personal information for the following purposes:
          </p>
          <ul className="!space-y-2 !list-disc !pl-6 !mb-6"> {/* Spacing between list items, explicit disc, padding, and bottom margin */}
            <li className="!leading-relaxed">To improve customer service: Information you provide helps us respond to your customer service requests and support needs more efficiently.</li>
            <li className="!leading-relaxed">To personalize user experience: We may use information in the aggregate to understand how our Users as a group use the services and resources provided on our Site.</li>
            <li className="!leading-relaxed">To improve our Site: We may use feedback you provide to improve our products and services.</li>
            <li className="!leading-relaxed">To process payments: We may use the information Users provide about themselves when placing an order only to provide service to that order. We do not share this information with outside parties except to the extent necessary to provide the service.</li>
            <li className="!leading-relaxed">To send periodic emails: We may use the email address to send User information and updates pertaining to their order. It may also be used to respond to their inquiries, questions, and/or other requests.</li>
          </ul>

          <h2 className="!mt-10 !mb-4">3. How We Protect Your Information</h2>
          <p className="!mb-6 !leading-relaxed">
            We adopt appropriate data collection, storage and processing practices and security measures to protect against
            unauthorized access, alteration, disclosure or destruction of your personal information, username, password,
            transaction information and data stored on our Site.
          </p>

          <h2 className="!mt-10 !mb-4">4. Sharing Your Personal Information</h2>
          <p className="!mb-6 !leading-relaxed">
            We do not sell, trade, or rent Users personal identification information to others. We may share generic aggregated
            demographic information not linked to any personal identification information regarding visitors and users with
            our business partners, trusted affiliates and advertisers for the purposes outlined above.
          </p>

          <h2 className="!mt-10 !mb-4">5. Changes to This Privacy Policy</h2>
          <p className="!mb-6 !leading-relaxed">
            ASCIIBytes has the discretion to update this privacy policy at any time. When we do, we will revise the updated
            date at the bottom of this page. We encourage Users to frequently check this page for any changes to stay
            informed about how we are helping to protect the personal information we collect. You acknowledge and agree
            that it is your responsibility to review this privacy policy periodically and become aware of modifications.
          </p>

          <h2 className="!mt-10 !mb-4">6. Your Acceptance of These Terms</h2>
          <p className="!mb-6 !leading-relaxed">
            By using this Site, you signify your acceptance of this policy. If you do not agree to this policy, please do
            not use our Site. Your continued use of the Site following the posting of changes to this policy will be
            deemed your acceptance of those changes.
          </p>

          <h2 className="!mt-10 !mb-4">7. Contacting Us</h2>
          <p className="!mb-2 !leading-relaxed"> {/* Tighter bottom margin before the address details */}
            If you have any questions about this Privacy Policy, the practices of this site, or your dealings with this site,
            please contact us at:
          </p>
          <div className="!mb-6 !leading-relaxed"> {/* Wrapper for address details for consistent spacing */}
            ASCIIBytes
            <br />
            <a href="mailto:info@asciibytes.in" className="text-indigo-600 hover:text-indigo-700 transition-colors duration-200">info@asciibytes.in</a> {/* Styled link */}
          </div>
          <p className="text-sm text-gray-500 !mt-10"> {/* Increased top margin for "Last updated" */}
            Last updated: {new Date().toLocaleDateString()}
          </p>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;